// removed by extract-text-webpack-plugin
module.exports = {"halfSizeWithOverflow":"styles__halfSizeWithOverflow___3WYVw"};


//////////////////
// WEBPACK FOOTER
// ./src/hocs/withHalfHeightOverflow/styles.css
// module id = 2736
// module chunks = 0